import { DashboardHeader, SideImageCard, UiButton } from "@/components";
import DashboardLayout from "@/components/layouts/dashboard-layout";
import { CommandeForm } from "@/components/molecules/commande";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ReactElement } from "react";

export default function NouvelCommande() {
  const navigate = useNavigate();

  return (
    <>
      <DashboardHeader subTitle="Gestion des commandes" />

      <div className="py-4">
        <SideImageCard imgSrc="/assets/images/chris-lee-70l1tDAI6rM-unsplash 1.png">
          <div className="">
            <UiButton
              variant="text"
              onClick={() => navigate(-1)}
              startIcon={<ArrowLeft />}
            >
              Retour
            </UiButton>

            <CommandeForm />
          </div>
        </SideImageCard>
      </div>
    </>
  );
}
